import React, { useEffect, useState } from "react";
import { BtnPrimary } from "../../../Components/share/buttons/Btn";
import { Modal } from "../../../Components/share/modal/Modal";
import ModalIdea from "../../../Components/layouts/StudentCourse/ModalIdea";
import NewIdeaModal from "../../../Components/layouts/StudentCourse/NewIdeaModal";
import useFetch from "../../../Hooks/useFetch";
import MainPagination from "../../../Components/share/Pageination/MainPagination";
import CoustomTable from "../../../Components/share/Table/CoustomTable";
import IdeasTable from "../../../Components/share/Table/IdeasTable";

function Idea() {
    const [ideas, setIdeas] = useState();
    const [idea, setIdea] = useState();
    const [editIdeaId, setEditIdeaId] = useState("");
    const [deleteIdeaId, setDeleteIdeaId] = useState("");
    const [modalbtn, setModalbtn] = useState(false);
    const [modalnewsesion, setModalnewsesion] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
    });

    const getUserIdeas = useFetch({
        method: "GET",
        url: "UserBootCampIdeaService/11/user_ideas",
        pagination: pagination,
        noHeader: false,
        trigger: true,
        setter: setIdeas,
    });
    //TODO : id bootcamp dynamic she

    const getUserIdeaById = useFetch({
        method: "GET",
        url: `UserBootCampIdeaService/${editIdeaId}`,
        trigger: false,
        noHeader: false,
        setter: setIdea,
    });

    const deleteUserIdea = useFetch({
        method: "DELETE",
        url: `UserBootCampIdeaService/${deleteIdeaId}`,
        caller: getUserIdeas,
        noHeader: false,
        trigger: false,
    });

    const updateUserIdeaPriority = useFetch({
        method: "PUT",
        url: `UserBootCampIdeaService/${editIdeaId}`,
        trigger: false,
        noHeader: false,
        setter: setIdea,
    });

    useEffect(() => {
        if (deleteIdeaId) {
            deleteUserIdea.reFetch();
        }
    }, [deleteIdeaId]);

    useEffect(() => {
        if (editIdeaId) {
            getUserIdeaById.reFetch();
        }
    }, [editIdeaId]);

    const showModal = () => {
        setModalbtn(true);
    };
    const showModalnewsesion = () => {
        setModalnewsesion(true);
    };

    return (
        <div>
            <div className="flex justify-between items-center">
                <h4 className="text-[2rem] text-purple-dark font-bold">
                    اطلاعات ایده های بوت کمپ
                </h4>
                <BtnPrimary
                    text="ایده جدید +"
                    className="px-16 py-7"
                    onClick={showModalnewsesion}
                />
            </div>
            {ideas && (
                <IdeasTable
                    list={ideas?.results}
                    showModal={showModal}
                    header={header}
                    lightbtn={true}
                    sort={true}
                    priority={true}
                    num={2}
                    setDeleteIdeaId={setDeleteIdeaId}
                    setEditIdeaId={setEditIdeaId}
                >
                    <Modal show={modalbtn}>
                        <ModalIdea
                            close={setModalbtn}
                            idea={idea}
                            getUserIdeas={getUserIdeas}
                            editIdeaId={editIdeaId}
                        />
                    </Modal>
                </IdeasTable>
            )}

            <MainPagination
                pagination={pagination}
                setPagination={setPagination}
                data={ideas?.results}
                pageSize={ideas?.page_count}
                className=" mt-[3rem]"
            />
            <Modal show={modalnewsesion}>
                <NewIdeaModal
                    close={setModalnewsesion}
                    getUserIdeas={getUserIdeas}
                />
            </Modal>
        </div>
    );
}

export default Idea;
const header = [
    { title: "نام ایده" },
    { title: "وضعیت ایده" },
    { title: "اولویت" },
];
